import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@clerk/clerk-react';
import type { MediaAgentBookingDto } from '@/types/dtos/media-agent/media-agent-pool.dto';
import { AGENT_POOLS_LIVE_REFETCH_MS } from '@/state/queries/agent-pools-live.constants';

export const LIST_MEDIA_AGENT_BOOKINGS_QUERY_KEY = 'media-agent-bookings';

export function useListMediaAgentBookingsQuery({
  enabled = true,
  status,
  limit = 100,
}: {
  enabled?: boolean;
  status?: string;
  limit?: number;
} = {}) {
  const { getToken } = useAuth();

  return useQuery({
    queryKey: [LIST_MEDIA_AGENT_BOOKINGS_QUERY_KEY, status, limit],
    enabled,
    queryFn: async () => {
      const token = (await getToken()) ?? '';
      const params = new URLSearchParams();
      if (status) params.set('status', status);
      params.set('limit', String(limit));
      const url = `${import.meta.env.VITE_API_URL}/media-agent/bookings?${params.toString()}`;
      const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
      if (!res.ok) throw new Error('Failed to load media agent bookings');
      const json = (await res.json()) as { bookings: MediaAgentBookingDto[] };
      return json.bookings;
    },
    refetchInterval: enabled ? AGENT_POOLS_LIVE_REFETCH_MS : false,
  });
}
